// src/layouts/quickbooks/Launch.js
// -----------------------------------------------------------------------------
// Route publique QuickBooks "Launch" demandée par Intuit.
// - Essaie de déterminer le tenant (company) via ?company=... ou localStorage.
// - Si pas de tenant -> redirige vers SignIn (avec next=/quickbooks/launch).
// - Sinon -> envoie vers le backend /quickbooks/connect/?schema=... qui
//            construi(t/ra) l'URL Intuit avec state=schema.
// -----------------------------------------------------------------------------

import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import api from "api/axios";

const normalize = (s) =>
  (s || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "")
    .slice(0, 63);

export default function Launch() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const qp = new URLSearchParams(location.search);
    const fromQuery = normalize(qp.get("company"));
    const fromLS = normalize(localStorage.getItem("company"));
    const company = fromQuery || fromLS;

    if (!company) {
      // Pas de tenant connu : laisse l'utilisateur choisir sur la page de connexion
      navigate("/authentication/sign-in?next=%2Fquickbooks%2Flaunch", { replace: true });
      return;
    }

    try {
      localStorage.setItem("company", company);
    } catch {}
    api.defaults.headers.common["X-Tenant"] = company;

    const base = (api.defaults.baseURL || "").replace(/\/+$/, "");
    // On délègue au backend la construction de l'URL Intuit (state=schema)
    window.location.href = `${base}/quickbooks/connect/?schema=${encodeURIComponent(company)}`;
  }, [location.search, navigate]);

  return (
    <Box textAlign="center" sx={{ py: 8 }}>
      <CircularProgress />
      <Typography variant="h6" sx={{ mt: 2 }}>
        Préparation de la connexion à QuickBooks…
      </Typography>
    </Box>
  );
}
